'use client'

import * as React from 'react'

export interface SocialShareContextModel {
  isOpen: boolean
  shareUrl: string | null
  openDialog: (shareUrl: string, headerText?: string) => void
  closeDialog: () => void
  dialogHeaderText: string | null
}

const SocialShareDialogContext = React.createContext<SocialShareContextModel>(null!)

export const SocialShareDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [shareUrl, setShareUrl] = React.useState<string | null>(null)
  const [dialogHeaderText, setDialogHeaderText] = React.useState<string | null>(null)

  const openDialog = (shareUrl: string, headerText?: string) => {
    setIsOpen(true)
    setDialogHeaderText(headerText ?? null)
    setShareUrl(shareUrl)
  }

  const closeDialog = () => {
    setShareUrl(null)
    setDialogHeaderText(null)
    setIsOpen(false)
  }

  return (
    <SocialShareDialogContext.Provider
      value={{ isOpen, openDialog, shareUrl, closeDialog, dialogHeaderText }}
    >
      {children}
    </SocialShareDialogContext.Provider>
  )
}

export const useSocialShareDialog = () => {
  const context = React.useContext(SocialShareDialogContext)

  if (context === undefined) {
    throw new Error('useSocialShareDialog must be used within a SocialShareDialogProvider')
  }

  return context
}
